// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xjDn","colBig":"styles_colBig__2l-BR","colSmall":"styles_colSmall__2fNpi"};